import { omit } from 'lodash';
import yup from 'src/libraries/validator.library';

// Schema
const RoleShape = {
  roleId: yup.number().required(),
  name: yup.string(),
  desc: yup.string(),
};

const AdminShape = {
  userRoleId: yup.number().required(),
  roleId: yup.number().required(),
  empNo: yup.string(),
  firstName: yup.string(),
  lastName: yup.string(),
  Role: yup
    .object()
    .shape({
      ...RoleShape,
    })
    .defined(),
};

export const AdminSchema = yup
  .object()
  .shape(omit(AdminShape, ['Role']))
  .defined();

export const AdminRoleSchema = yup
  .object()
  .shape({
    ...AdminShape,
  })
  .defined();

export const AdminListSchema = yup
  .object({
    count: yup.number(),
    rows: yup.array().of(AdminRoleSchema).defined(),
  })
  .defined();

export const AdminFormSchema = yup
  .object({
    empNo: yup.string().required(),
    roleId: yup.number().required(),
  })
  .defined();

export const AdminResponsePayloadSchema = yup
  .object({
    user: yup
      .object({
        userRoleId: yup.number(),
        empNo: yup.string(),
        roleId: yup.number(),
        firstName: yup.string(),
        lastName: yup.string(),
      })
      .defined(),
  })
  .defined();

export type IAdmin = yup.InferType<typeof AdminSchema>;
export type IAdminRole = yup.InferType<typeof AdminRoleSchema>;
export type IAdminList = yup.InferType<typeof AdminListSchema>;
export type IAdminForm = yup.InferType<typeof AdminFormSchema>;
